import { render, staticRenderFns } from "./MainCourseComponent.vue?vue&type=template&id=15e54f08"
import script from "./MainCourseComponent.vue?vue&type=script&lang=js"
export * from "./MainCourseComponent.vue?vue&type=script&lang=js"
import style0 from "./MainCourseComponent.vue?vue&type=style&index=0&id=15e54f08&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports